import React from 'react';
import { Button } from './Button';
import { motion } from 'framer-motion';
import { Star, CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-cream pt-12 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-261">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-12" data-id="element-262">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="flex-1 text-center lg:text-left z-10" data-id="element-263">
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-forest font-bold leading-tight mb-6" data-id="element-264">
            Adiós Hinchazón: 3-Day Reset
          </h1>
          <h2 className="text-xl md:text-2xl text-forest-light font-medium mb-8" data-id="element-265">
            Un plan simple de 3 días para ayudar a mujeres ocupadas a deshinchar
            abdomen y cuerpo, reducir la retención de líquidos y sentirse más
            ligeras sin dietas extremas.
          </h2>

          <ul className="space-y-3 mb-10 text-left mx-auto lg:mx-0 max-w-lg" data-id="element-266">
            <li className="flex items-start gap-3" data-id="element-267">
              <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-268" />
              <span className="text-gray-800 text-lg" data-id="element-269">
                Ideal si amaneces inflada, pesada o con el abdomen hinchado
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-270">
              <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-271" />
              <span className="text-gray-800 text-lg" data-id="element-272">
                Incluye una guía clara de qué comer, qué evitar y cómo
                organizarte sin complicarte
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-273">
              <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-274" />
              <span className="text-gray-800 text-lg" data-id="element-275">
                Pensado para mujeres reales en USA con poco tiempo
              </span>
            </li>
          </ul>

          <div className="flex flex-col items-center lg:items-start" data-id="element-276">
            <motion.button animate={{
            scale: [1, 1.03, 1],
            boxShadow: ['0 0 0 0 rgba(212, 175, 55, 0.4)', '0 0 20px 8px rgba(212, 175, 55, 0.3)', '0 0 0 0 rgba(212, 175, 55, 0.0)']
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.97
          }} onClick={() => document.getElementById('offer-price')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })} className="inline-block bg-gold hover:bg-gold-hover text-forest font-bold py-4 px-8 rounded-full shadow-lg transition-colors text-lg md:text-xl w-full md:w-auto text-center cursor-pointer mb-4" data-id="element-277">
              Quiero empezar mi 3-Day Reset
            </motion.button>
            <p className="text-sm text-gray-600 font-medium" data-id="element-278">
              Baja para ver todo lo que incluye, tus bonos y el acceso
              inmediato.
            </p>
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex-1 w-full max-w-md lg:max-w-full relative" data-id="element-279">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="relative z-20 bg-white rounded-2xl shadow-xl border border-sage-dark/40 p-4 md:p-5 mb-6 max-w-md mx-auto" data-id="element-280">
            <div className="flex items-start gap-3" data-id="element-281">
              <img src="https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=160&h=160&fit=crop&crop=faces" alt="Camila R." className="w-12 h-12 md:w-14 md:h-14 rounded-full object-cover flex-shrink-0 border-2 border-gold" data-id="element-282" />
              <div className="flex-1 text-left" data-id="element-283">
                <div className="flex items-center gap-0.5 mb-1" data-id="element-284">
                  {[0, 1, 2, 3, 4].map(i => <Star key={i} className="w-4 h-4 text-gold fill-gold" data-id="element-285" />)}
                </div>
                <p className="text-gray-700 text-sm md:text-base leading-snug italic mb-1" data-id="element-286">
                  "Bajé 3 libras de hinchazón en el primer fin de semana. Me
                  sentí ligera otra vez."
                </p>
                <p className="text-forest font-semibold text-xs md:text-sm" data-id="element-287">
                  — Camila R., Miami
                </p>
              </div>
            </div>
          </motion.div>
          <div className="absolute inset-0 bg-sage rounded-full blur-3xl opacity-50 transform scale-110" data-id="element-288"></div>
          <img src="https://cdn.magicpatterns.com/uploads/obmiXzA8Rtge2bMWcaqEoG/adios_inchazon_3_Day_Reset.png" alt="Adiós Hinchazón: 3-Day Reset" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl rounded-2xl" data-id="element-289" />
        </motion.div>
      </div>
    </section>;
}